import api from "@/auth/api";
import { alertSuccess, alertError } from "@/components/Alert";
import React, { useEffect, useState } from "react";
import { fetchPanelUser } from "@/slices/panelUserSlice";
import { useDispatch, useSelector } from "react-redux";



function Add({ onSuccess , onClose}) {
    const dispatch = useDispatch();
  
  const [userId, setUserId] = useState("");
  const [type, setType] = useState("");
  const [detail, setDetail] = useState("");
  const {panelUserList , search} = useSelector((state) => state.panelUser);


  // const [panelUserList, setPanelUserList] = useState([]);
  const [blackListType, setBlackListType] = useState([]);

  // const getPaneluserList = async () => {
  //   try {
  //     const resp = await api.get("/PanelHome/panel/panelUser");
  //     setPanelUserList(resp.data.result);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const getBlackListType = async () => {
    try {
      const response = await api.get("/PanelHome/panel/blackListType");
      setBlackListType(response.data.result);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


    useEffect(() => {
      // Fetch all users for the modal
      dispatch(fetchPanelUser({ fetchAll: true , search }));
  }, [dispatch]);

  useEffect(() => {
    // getPaneluserList();
    getBlackListType();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post("/PanelHome/panel/UserblackList", {
        userId:parseInt(userId),
        Type:parseInt(type),
        detail,
      });
      if (!response.error) {
        alertSuccess("Black list type added successfully");
        onClose()
        onSuccess();
      }
    } catch (error) {
      console.error("Error:", error);
      alertError(error.response?.data?.errors || "An error occurred");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex items-center flex-col gap-4 p-4"
    >
      <select
        value={userId}
        onChange={(e) => setUserId(e.target.value)}
        required
        className="border p-2 rounded w-full max-w-sm"
      >
        <option value="" disabled>
          Select User
        </option>
        {panelUserList?.result?.map((user) => (
          <option key={user.id} value={user.id}>
            {user.fullName || user.email}
          </option>
        ))}
      </select>

      <select
        value={type}
        onChange={(e) => setType(e.target.value)}
        required
        className="border p-2 rounded w-full max-w-sm"
      >
        <option value="" disabled>
          Select Type
        </option>
        {blackListType.map((item) => (
          <option key={item.id} value={item.id}>
            {item.title}
          </option>
        ))}
      </select>

      <input
        type="text"
        placeholder="Enter detail"
        required
        value={detail}
        onChange={(e) => setDetail(e.target.value)}
        className="border p-2 rounded w-full max-w-sm"
      />

      <button
        type="submit"
        className="activeBtn rounded-sm w-fit text-white p-2"
      >
        Submit
      </button>
    </form>
  );
}

export default Add;
